export default __webpack_public_path__ + "static/media/IMG1.fdbb43cd.jpg";